<template>
  <div>
    <el-table
    :data="tableData"
    style="width: 100%">
    <el-table-column
      fixed
      prop="caseId"
      label="案件ID">
    </el-table-column>
    <el-table-column
      prop="caseNo"
      label="案件编号">
    </el-table-column>
    <el-table-column
      prop="optTypeName"
      label="操作类型">
    </el-table-column>
    <el-table-column
      prop="optUser"
      label="操作人ID">
    </el-table-column>
    <el-table-column
      prop="optUserName"
      label="操作人">
    </el-table-column>
    <!-- optExtra -->
    <el-table-column
      label="操作详情">
      <template slot-scope="scope">
         <el-button type="text" size="small" @click="see(scope.row.optExtra)">查看操作详情</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-dialog title="操作详情" :visible.sync="dialogFormVisible">
  <el-form :model="form">
    <el-form-item label="被保险人:" :label-width="formLabelWidth">
     <span>{{ form.victimName }}</span>
    </el-form-item>
    <el-form-item label="报案人:" :label-width="formLabelWidth">
     <span>{{ form.reportUser }}</span>
    </el-form-item>
     <el-form-item label="小保单号:" :label-width="formLabelWidth">
     <span>{{ form.miniPolicy }}</span>
    </el-form-item>
    <el-form-item label="保险公司座席工号:" :label-width="formLabelWidth">
     <span>{{ form.insuranceSeat }}</span>
    </el-form-item>
    <el-form-item label="产品名称:" :label-width="formLabelWidth">
     <span>{{ form.caseProductName }}</span>
    </el-form-item>
    <el-form-item label="来源说明:" :label-width="formLabelWidth">
     <span>{{ form.caseSrcDesc }}</span>
    </el-form-item>
     <el-form-item label="被保人证件:" :label-width="formLabelWidth">
     <span>{{ form.idNo }}</span>
    </el-form-item>
    <el-form-item label="地址:" :label-width="formLabelWidth">
     <span>{{ form.addr }}</span>
    </el-form-item>
     <el-form-item label="案件信息来源:" :label-width="formLabelWidth">
     <span>{{ form.caseSrc }}</span>
    </el-form-item>
     <el-form-item label="保单号码:" :label-width="formLabelWidth">
     <span>{{ form.insurancePolicyNo }}</span>
    </el-form-item>
    <el-form-item label="服务经过:" :label-width="formLabelWidth">
     <span>{{ form.incidentDesc }}</span>
    </el-form-item>
    <el-form-item label="报案时间:" :label-width="formLabelWidth">
     <span>{{ form.reportTs }}</span>
    </el-form-item>
    <el-form-item label="上门服务时间:" :label-width="formLabelWidth">
     <span>{{ form.incidentTs }}</span>
    </el-form-item>
     <el-form-item label="性别:" :label-width="formLabelWidth">
     <span>{{ form.gender }}</span>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
  </div>
</el-dialog>
  </div>
</template>
<script>
  import { caselist_case_record } from '@/views/axios/api.js'
   import constants from '@/util/constants.js';
export default {
  data() {
    return {
      token: JSON.parse(window.localStorage.getItem("data")).data,
       tableData: [],
       dialogFormVisible:false,
        form: {
         
        },
        formLabelWidth: '130px'
    }
  },
  methods: {
    see(row) {
      console.log(JSON.parse(row))
      this.dialogFormVisible = true
      
      this.form = JSON.parse(row)
      if( this.form.gender == 1) {
          this.form.gender = '男'
      }else {
         this.form.gender = '女'
      }
       
      this.form.incidentTs = constants.time(this.form.incidentTs)
      this.form.reportTs = constants.time(this.form.reportTs)
    },
    getData() {
      caselist_case_record({
        token:this.token,
       caseId:this.$route.query.caseid
      }).then((res)=>{
        for(var i = 0; i<res.data.obj.length; i++) {
          if(res.data.obj[i].optType == '70'){
            res.data.obj[i].optTypeName = '指挥中心，案件草稿创立'
          }else if(res.data.obj[i].optType == '71') {
            res.data.obj[i].optTypeName = '指挥中心，案件草稿编辑'
          }else if(res.data.obj[i].optType == '72') {
            res.data.obj[i].optTypeName = '指挥中心，案件草稿删除'
          }else if(res.data.obj[i].optType == '100') {
            res.data.obj[i].optTypeName = '指挥中心，案件创立'
          }else if(res.data.obj[i].optType == '101') {
            res.data.obj[i].optTypeName = '指挥中心，案件编辑'
          }else if(res.data.obj[i].optType == '102') {
            res.data.obj[i].optTypeName = '指挥中心，案件上传文件'
          }else if(res.data.obj[i].optType == '120') {
            res.data.obj[i].optTypeName = '指挥中心，启动救援，等待授权'
          }else if(res.data.obj[i].optType == '130') {
            res.data.obj[i].optTypeName = '监管机构，同意启动救援'
          }else if(res.data.obj[i].optType == '140') {
            res.data.obj[i].optTypeName = '指挥中心，提交救援机构，等待报价'
          }else if(res.data.obj[i].optType == '150') {
            res.data.obj[i].optTypeName = '指挥中心，确认报价，等待监管机构确认'
          }else if(res.data.obj[i].optType == '160') {
            res.data.obj[i].optTypeName = '监管机构，授权通过'
          }else if(res.data.obj[i].optType == '170') {
            res.data.obj[i].optTypeName = '监管机构，授权拒绝'
          }else if(res.data.obj[i].optType == '180') {
            res.data.obj[i].optTypeName = '指挥中心，开始救援'
          }else if(res.data.obj[i].optType == '190') {
            res.data.obj[i].optTypeName = '救援机构，完成救援'
          }else if(res.data.obj[i].optType == '110') {
            res.data.obj[i].optTypeName = '指挥中心确认完成'
          }else if(res.data.obj[i].optType == '111') {
            res.data.obj[i].optTypeName = '关闭案件'
          }else if(res.data.obj[i].optType == '112') {
            res.data.obj[i].optTypeName = '监管机构，拒绝启动救援'
          }else if(res.data.obj[i].optType == '113') {
            res.data.obj[i].optTypeName = '指挥中心取消报价'
          }
        // res.data.obj[i].reportTs =  constants.time(res.data.obj[i].reportTs)
        }
        
        this.tableData = res.data.obj
        console.log(res)
      })
    }
  },
   mounted() {
     this.getData()
     // 1a1a321a32
   }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/logPage.vue